var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShieldFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.01 23.677.497.333.43-.288C19.235 19.546 23 12.633 23 5.247V3.131L12.46.01 2 3.163v2.072c0 7.36 3.738 14.254 10.01 18.442ZM7.478 11.321l3.606 3.429 7.966-7.632-1.072-1.043-6.9 6.615-2.541-2.412-1.059 1.043Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShieldFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ShieldFilled.bd885fc6b194a076ba99eeb757742b5a.svg";